import { Controller } from "@hotwired/stimulus"

// Submits the form as soon as a field changes, so filter chips and select
// menus need no separate "Opdater" button. Replaces inline onchange handlers,
// which the Content Security Policy blocks.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  // A date field reports a change on every keystroke that makes a valid date,
  // and year "2" is one, so a typed date would submit halfway through 2026. A
  // date picked in the calendar comes without a key press and submits at once;
  // a typed one waits until the person leaves the field. Enter submits the
  // form on its own.
  focusDate() {
    this.typed = false
    this.held = false
  }

  typeDate() {
    this.typed = true
  }

  changeDate(event) {
    event.stopPropagation()

    if (this.typed) {
      this.held = true
    } else {
      this.submit()
    }
  }

  leaveDate() {
    if (this.held) this.submit()
  }
}
